import { render, staticRenderFns } from "./CardCategory.vue?vue&type=template&id=09910a35&"
import script from "./CardCategory.vue?vue&type=script&lang=ts&"
export * from "./CardCategory.vue?vue&type=script&lang=ts&"
import style0 from "./CardCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports